/**
 * Master-data catalogs persisted in the browser and invalidated by
 * `master_data.changed`. Keep in sync with
 * `backend/src/shared/infrastructure/realtime/publishMasterDataChanged.ts`.
 */
export const MASTER_DATA_RESOURCES = [
  'appointment.types',
  'treatment-catalog.list',
  'treatment-catalog.categories',
  'treatment-catalog.uoms',
  'treatment-journal.list',
  'clinic.chairs',
  'patient.customer-sources',
  'staff.departments',
  'staff.roster',
  'expense.categories',
  'income.categories',
  'payment.methods',
  'prescription.drugs',
  'prescription.templates',
  'scheduling.shift-types',
  'scheduling.time-off-types',
  'overtime.types',
  'labo.work-types',
  'labo.materials',
  'labo.shades',
  'labo.partners',
  'messaging.canned-responses',
  'payroll.components',
  'kpi.templates',
  'inventory.taxonomy',
] as const;

export type MasterDataResource = (typeof MASTER_DATA_RESOURCES)[number];

/** Query key prefix invalidated when that catalog changes. */
export const MASTER_DATA_QUERY_PREFIX: Record<MasterDataResource, readonly string[]> = {
  'appointment.types': ['appointment', 'types'],
  'treatment-catalog.list': ['treatment-catalog', 'list'],
  'treatment-catalog.categories': ['treatment-catalog', 'categories'],
  'treatment-catalog.uoms': ['treatment-catalog', 'uoms'],
  'treatment-journal.list': ['treatment-journal'],
  'clinic.chairs': ['clinic', 'chairs'],
  'patient.customer-sources': ['patient', 'customer-sources'],
  'staff.departments': ['staff', 'departments'],
  'staff.roster': ['staff', 'roster'],
  'expense.categories': ['expense', 'categories'],
  'income.categories': ['income', 'categories'],
  'payment.methods': ['payment', 'methods'],
  'prescription.drugs': ['prescription', 'drugs'],
  'prescription.templates': ['prescription', 'templates'],
  'scheduling.shift-types': ['scheduling', 'shift-types'],
  'scheduling.time-off-types': ['scheduling', 'time-off-types'],
  'overtime.types': ['overtime', 'types'],
  'labo.work-types': ['labo', 'work-types'],
  'labo.materials': ['labo', 'materials'],
  'labo.shades': ['labo', 'shades'],
  'labo.partners': ['labo', 'partners'],
  'messaging.canned-responses': ['messaging', 'canned-responses'],
  'payroll.components': ['payroll', 'components'],
  'kpi.templates': ['kpi', 'templates'],
  'inventory.taxonomy': ['inventory', 'taxonomy'],
};
